import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { RegisterComponent } from './register';
import { AuthGuard } from './_helpers';
import { CategoriesComponent } from './categories';
import { SearchComponent } from './search/search.component';
import { SearchscreenComponent } from './searchscreen/searchscreen.component';
import { FiledetailsComponent } from './sidepanel/filedetails/filedetails.component';
import { DialogUploadComponent } from './sidepanel/dialog-upload/dialog-upload.component';
import { UploadComponent } from './upload/upload.component';
import { CategoryConfigComponent } from './configuration/category-config/category-config.component';
import { SearchConfigComponent } from './configuration/search-config/search-config.component';
import { ConfigHomeComponent } from './configuration/home/home.component';
import { FileinboxComponent } from './fileinbox/fileinbox.component';
import { TaskinboxComponent } from './taskinbox/taskinbox.component';
import { VirtualFoldersComponent } from './virtual-folders/virtual-folders.component';
import { GlacierComponent } from './glacier/glacier.component';
import { VirtualfolderComponent } from './mcrvirtualfolder/virtualfolder.component';
import { ExportComponent } from './status/export/export.component';
import { SsoLoginComponent } from './sso-login/sso-login.component';

import { SAMLLoginComponent } from './saml-login/saml-login.component';

import { InsightsComponent } from './insights/insights.component';
import { LegacyIndexComponent } from './legacy-index/legacy-index.component';
import { DeDuplicationComponent } from './de-duplication/de-duplication.component';
import { BulkUpdateStatusComponent } from './status/bulk-update-status/bulk-update-status.component';
import { StatusComponent } from './status/status.component';
//import { CategoryComponent } from './category';

const routes: Routes = [

  //{ path: '', redirectTo: 'ssologin', pathMatch: 'full' },
  { path: 'home', component: HomeComponent},  
  { path: 'insights', component: InsightsComponent, canActivate: [AuthGuard]},

  // MCRTX Changes
  // { path: 'login', component: LoginComponent },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then(
        (m) => m.LoginModule
      )    
  },

  { path: 'ssologin', component: SAMLLoginComponent },

  { path: 'register', component: RegisterComponent },
  {
    path: 'categories',
    component: CategoriesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'category',
    component: CategoriesComponent,
    canActivate: [AuthGuard],
  },
  { path: 'search', component: SearchComponent, canActivate: [AuthGuard] },  
  { path: 'legacyIndex', component: LegacyIndexComponent, canActivate: [AuthGuard] },  
  { path: 'upload', component: UploadComponent, canActivate: [AuthGuard] },
  {
    path: 'fileInbox',
    component: FileinboxComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'config/home',
    component: ConfigHomeComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'taskInbox',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./taskinbox/taskinbox.module').then(
        (m) => m.TaskInboxModule
      ),
  },
//   {
//     path: 'taskInbox',
//     component: TaskinboxComponent,
//     canActivate: [AuthGuard],
//   },
  {
    path: 'folders',
    component: VirtualFoldersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'glacierStatus',
    component: GlacierComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'metadataVirtualFolder',
    component: VirtualfolderComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'deduplication',
    component: DeDuplicationComponent,
    canActivate: [AuthGuard],
  },
  { path: 'export', component: StatusComponent, canActivate: [AuthGuard] }
  // {
  //   path: 'bulkUpdateStatus',
  //   component: BulkUpdateStatusComponent,
  //   canActivate: [AuthGuard],
  // },
  //{ path: 'config/category', component: CategoryConfigComponent, canActivate: [AuthGuard] },
  //{ path: 'config/search', component: SearchConfigComponent, canActivate: [AuthGuard] },
  //{ path: 'category/:categoryId', component: CategoryComponent, canActivate: [AuthGuard] },

  // otherwise redirect to home

  // { path: '**', redirectTo: 'home' },

];

export const appRoutingModule = RouterModule.forRoot(routes);
